module.exports = __webpack_public_path__ + "home-02.png?856333e44977b3d2df8fb047f54f1ecd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wap/home-02.png
// module id = 173
// module chunks = 0